@if (ErrorMessage !== error_B2C_User_Cancellation) {
  <div class="main-container">
    <swal #errorAlert width="520px" icon="error" [showCancelButton]="false" [showConfirmButton]="false"
      [allowEscapeKey]="false" [allowOutsideClick]="false" [heightAuto]="false">
      <ng-container *swalPortal="swalTargets.title">
        <b>{{ titleMessage ?? 'Cargando...' | translate }}</b> <br>
        <small>{{ ErrorMessage ?? 'Cargando...' | translate}}
          @if (ErrorMessage === 'B2C-Environment-Forbidden' || ErrorMessage === 'B2C-Environment-lapsed') {
            <span>({{ entorno | translate }})</span>
          }
        </small>
      </ng-container>
      <ng-container *swalPortal="swalTargets.actions">
        <button mat-flat-button color="primary" [routerLink]="['/']" (click)="restart()">
          <mat-icon>home</mat-icon>
          {{ 'volver-a-inicio' | translate }}
        </button>
      </ng-container>
      <ng-container *swalPortal="swalTargets.footer">
        <p class="footer-text">SOLFIX SmartCity <small>|</small> {{ entorno | translate }} <small>|</small> v{{ version }}</p>
        <img height="30px" src="assets/imagenes/icons/512x512.png" alt="Logo solfix">
      </ng-container>
    </swal>
  </div>
}